import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';
import { LoadingFallback } from '@/components/LoadingFallback';
import { type TabName } from '@/config/permissions';

interface TabGuardProps {
  children: ReactNode;
  requiredTab: TabName;
}

export function TabGuard({ children, requiredTab }: TabGuardProps) {
  const { hasPermission, loading } = usePermissions();

  // Still loading permissions
  if (loading) {
    return <LoadingFallback message="Checking permissions..." />;
  }

  // User doesn't have access
  if (!hasPermission(requiredTab, 'view')) {
    return <Navigate to="/unauthorized" replace />;
  }

  // User has access
  return <>{children}</>;
}